/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { SubscriptionTokenDto } from '@swagger-services/waiting-room/model/subscriptionTokenDto';
import { RefreshComponent } from '../components/refresh/refresh.component';

@Injectable({ providedIn: 'root' })
export class NotificationSubscriberService extends RefreshComponent {
  private _action$: BehaviorSubject<boolean | undefined> = new BehaviorSubject<boolean | undefined>(undefined);
  private _shouldRefetchToken$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private tokenUrl!: string;
  private group!: string;
  private webSocket!: WebSocket;

  get action$(): Observable<boolean> {
    return this._action$.pipe(filter((action) => action !== undefined)) as Observable<boolean>;
  }

  get shouldRefetchToken$(): Observable<boolean> {
    return this._shouldRefetchToken$.asObservable();
  }

  unsubscribe(): void {
    this.webSocket.close();
  }

  setToken(token: SubscriptionTokenDto): void {
    const queryFromToken = new URL(token.url).search;
    const accessToken: string = new URLSearchParams(queryFromToken).get('access_token')!;
    this.startRefreshSession(accessToken);
    this.tokenUrl = token.url;
  }

  setGroup(orgSlug: string, hash: string): void {
    this.group = `${orgSlug}-${hash}`;
  }

  subscribeToNotification(): void {
    if (this.webSocket) this.webSocket.close();

    this.webSocket = new WebSocket(this.tokenUrl, 'json.webpubsub.azure.v1');

    this.webSocket.onopen = (): void => {
      this.webSocket.send(
        JSON.stringify({
          type: 'joinGroup',
          group: this.group,
        }),
      );
    };

    this.webSocket.onmessage = (event: MessageEvent): void => {
      console.log(`Web socket event type: ${event.type}, data: ${event.data}`);
      const message = JSON.parse(event.data);
      if (message.type !== 'message') return;
      console.log(`Action ${JSON.stringify(message.data?.action)}`);
      this.action(!!message.data?.action);
    };

    this.webSocket.onclose = (event: CloseEvent): void => {
      console.log(`Web socket closing ${JSON.stringify(event)}`);
    };
  }

  refreshToken(): void {
    this.setRefetchToken(true);
  }

  getTokenExpirationDate(token: string): Date | null {
    return this.jwtHelper.getTokenExpirationDate(token);
  }

  private action(shouldInit: boolean): void {
    this._action$.next(shouldInit);
  }

  private setRefetchToken(shouldRefetch: boolean): void {
    this._shouldRefetchToken$.next(shouldRefetch);
  }
}
